import i18n from "@assets/i18n";

export default [
    {
        path: '/statistics/course',
        name: 'courseStatistics',
        component: () => import('@/pages/Statistics/CourseStatistics'),
    }, {
        path: '/statistics/image',
        name: 'imageStatistics',
        component: () => import('@/pages/Statistics/ImageStatistics'),
    },{
        path: '/statistics/imageJP',
        name: 'imageStatisticsJP',
        component: () => import('@/pages/Statistics/ImageStatisticsJP'),
    }, {
        path: '/statistics/resource',
        name: 'resourceStatistics',
        component: () => import('@/pages/Statistics/ResourceStatistics'),
    }, {
        path: '/statistics/certificate',
        name: 'certificateStatistics',
        component: () => import('@/pages/Statistics/CertificateStatistics'),
    }, {
        path: '/statistics/examQuestion',
        name: 'examQuestionStatistics',
        component: () => import('@/pages/Statistics/ExamQuestionStatistics'),
        children: [{
            path: 'edit/:id/:type',
            name: 'statisticsTopicEdit',
            component: () => import('@/pages/Topic/MyTopicAdd'),
            props: true,
            meta: {title: i18n.t('topic.editTopic')},
        }]
    }, {
        path: '/statistics/exam',
        name: 'examStatistics',
        component: () => import('@pages/Statistics/Exam/ExamStatistics'),
        children: [{
            path: 'detail/:processID',
            name: 'examDetail',
            component: () => import('@pages/Statistics/Exam/ExamDetailStatistics'),
            props: true,
            meta: {title: i18n.t('count.examDetailTitle')},
            children: [{
                path: 'edit/:id/:type',
                name: 'examDetailTopicEdit',
                component: () => import('@/pages/Topic/MyTopicAdd'),
                props: true,
                meta: {title: i18n.t('topic.editTopic')},
            }, {
                path: 'edit/:id',
                name: 'examDetailGraphicEdit',
                component: () => import('@pages/Paper/Topic/EditTheoryGraphicTopic'),
                props: true,
                meta: {title: i18n.t('topic.editTopic')},
            }]
        }]
    }, {
        path: '/statistics/train',
        name: 'trainStatistics',
        component: () => import('@pages/Statistics/Train/TrainStatistics'),
        children: [{
            path: 'detail/:planId',
            name: 'trainDetail',
            component: () => import('@pages/Statistics/Train/TrainDetailStatistics'),
            props: true,
            meta: {title: i18n.t('count.trainDetailTitle')},
        },
            {
                path: 'offlineDetail/:planId',
                name: 'trainOfflineDetail',
                component: () => import('@pages/Statistics/Train/TrainOfflineStatistics'),
                props: true,
                meta: {title: i18n.t('count.trainDetailTitle')},
            },{
                path: 'surveyPaper/:id',
                name: 'surveyPaper',
                component: () => import('@/pages/Statistics/TrainSurveyPaper'),
                props: true,
                meta: {title: i18n.t('survey.statisticsTitle')},
            }]
    }, {
        path: '/statistics/questionnaire',
        name: 'questionnaireStatistics',
        component: () => import('@/pages/Statistics/Questionnaire/Index'),
        children: [{
            path: 'detail/:id',
            name: 'questionnaireDetailStatistics',
            component: () => import('@/pages/Statistics/Questionnaire/Detail'),
            props: true,
            meta: {title: i18n.t('survey.detail')},
        }]
    },{
        path: '/statistics/fiscanImage',
        name: 'fiscanImageStatistics',
        component: () => import('@pages/Statistics/Fiscan/Index'),
        children: [{
            path: 'studyDetail/:userID',
            name: 'fiscanStudyDetail',
            component: () => import('@pages/Statistics/Fiscan/FiscanStudyDetailStats'),
            props: true,
            meta: {title: i18n.t('res.fiscanImage')},
        }]
    },{
        path: '/statistics/nuctechImage',
        name: 'nuctechImageStatistics',
        component: () => import('@/pages/Statistics/NuctechImageStatistic'),
        children: [{
            path: 'detail/:userID/:searchData',
            name: 'nuctechImageDetail',
            component: () => import('@/pages/Statistics/NuctechImageDetailStatistic'),
            props: true,
            meta: {title: i18n.t('res.nuctechImage')},
        }]
    },{
        path: '/statistics/omit',
        name: 'omitStats',
        component: () => import('@/pages/Statistics/Omit/Index'),
        children: [{
            path: 'orgDetail/:orgID/:name',
            name: 'omitOrgDetailStats',
            component: () => import('@/pages/Statistics/Omit/OmitOrganizationDetail'),
            props: true,
            meta: {title: '机构漏检详情'},
        }, {
            path: 'userDetail/:userID/:name',
            name: 'omitUserDetailStats',
            component: () => import('@/pages/Statistics/Omit/OmitUserDetail'),
            props: true,
            meta: {title: '安检员漏检详情'},
        }]
    }, {
        path: '/statistics/credit',
        name: 'creditStatistics',
        component: () => import('@/pages/Statistics/Credit/Index'),
        children: [{
            path: 'detail/:userID',
            name: 'creditDetail',
            component: () => import('@/pages/Statistics/Credit/CreditDetail'),
            props: true,
            meta: {title: '学分详情'},
        }]
    },{
        path: '/statistics/living',
        name: 'livingStatistics',
        component: () => import('@/pages/Statistics/LivingStatistics'),
        children: [{
            path: 'detail/:liveID',
            name: 'livingDetail',
            component: () => import('@/pages/Statistics/LivingDetailStatistics'),
            props: true,
            meta: {title: '直播详情'},
        }]
    },{
        path: '/statistics/excise',
        name: 'exciseStatistics',
        component: () => import('@/pages/Statistics/Excise/Index'),
        children: [{
            path: 'imageDetail/:userID/:searchData',
            name: 'imageExciseDetail',
            component: () => import('@/pages/Statistics/Excise/ImageExciseDetail'),
            props: true,
            meta: {title: '图像练习详情'},
        },
            {
                path: 'theoryDetail/:userID/:searchData',
                name: 'theoryExciseDetail',
                component: () => import('@/pages/Statistics/Excise/TheoryExciseDetail'),
                props: true,
                meta: {title: '理论练习详情'},
            },
            {
                path: 'fiscanDetail/:userID/:searchData',
                name: 'fiscanExciseDetail',
                component: () => import('@/pages/Statistics/Excise/FiscanExciseDetail'),
                props: true,
                meta: {title: '职鉴练习详情'},
            }
        ]
    },{
        path: '/statistics/checkin',
        name: 'checkinStatistics',
        component: () => import('@/pages/Statistics/CheckinStatistics'),
    },
    // 深圳货站
    {
        path: '/statistics/shenzhen',
        name: 'shenzhenStats',
        component: () => import('@/pages/Statistics/Custom/ShenZhenStats'),
    },
]
